/* Warenkorb-Seite (sections/main-cart-items.liquid):
   1. Bild aus dem Konfigurator: fragt den konfig-bild-Dienst (Repo area-s51-wawi) mit der
      „3D Customizer URL“ ab. Beim ersten Aufruf wird gerendert (~10–30 s), bis dahin
      Platzhalter. Fertige Bild-URLs werden pro Sitzung gemerkt.
   2. easyCredit-Raten: echte Raten aus dem öffentlichen easyCredit-Ratenrechner
      (Webshop 1.de.12372.1) inkl. Sollzins/eff. Jahreszins und repräsentativem Beispiel —
      nie selbst gerechnet (Zinsen!). Außerhalb 200–10.000 € nur Hinweis.
   Dawns cart.js ersetzt #main-cart-items .js-contents nach jeder Mengenänderung,
   darum wird nach jeder Änderung neu initialisiert (MutationObserver). */
(() => {
  const IMG_FN = 'https://ehfiyutukrutvdnbjkaf.supabase.co/functions/v1/konfig-bild';
  const EC_API = 'https://ratenkauf.easycredit.de/api/ratenrechner/v3/webshop/1.de.12372.1/installmentplans';
  const TERMS = [12, 24, 36, 48, 60];
  const POLL_MS = 2500;
  const POLL_MAX_MS = 120000;

  const store = {
    get(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} },
  };
  const eur = (n) => Number(n).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';

  /* --- 1. Konfigurator-Bild ------------------------------------------------ */
  const polling = new Map(); // konfig-url -> Promise<string|null>

  function fetchImage(url) {
    if (polling.has(url)) return polling.get(url);
    const p = (async () => {
      const t0 = Date.now();
      while (Date.now() - t0 < POLL_MAX_MS) {
        try {
          const r = await fetch(IMG_FN + '?u=' + encodeURIComponent(url));
          const j = await r.json();
          if (j.status === 'done' && j.url) return j.url;
          if (j.status !== 'pending') return null;
        } catch (e) {
          return null;
        }
        await new Promise((ok) => setTimeout(ok, POLL_MS));
      }
      return null;
    })();
    polling.set(url, p);
    return p;
  }

  function show(el, src) {
    const img = el.querySelector('.a51c-render__img');
    if (!img) return;
    img.onload = () => { el.dataset.state = 'done'; };
    img.hidden = false;
    img.src = src;
  }

  function initImages(root) {
    root.querySelectorAll('.a51c-render[data-konfig-url]').forEach((el) => {
      const url = el.dataset.konfigUrl;
      if (!url || el.dataset.init) return;
      el.dataset.init = '1';
      const cached = store.get('a51c-img:' + url);
      if (cached) return show(el, cached);
      fetchImage(url).then((src) => {
        if (src) {
          store.set('a51c-img:' + url, src);
          show(el, src);
        } else {
          el.dataset.state = 'failed';
          const hint = el.querySelector('.a51c-render__hint');
          if (hint) hint.textContent = '';
        }
      });
    });
  }

  /* --- 2. easyCredit ------------------------------------------------------- */
  const plansCache = new Map(); // Betrag in Cent -> Promise<{plans, example}|null>
  let term = null; // vom Kunden gewählte Laufzeit (bleibt über Neu-Renderings erhalten)

  function getPlans(cents) {
    if (plansCache.has(cents)) return plansCache.get(cents);
    const p = (async () => {
      if (cents < 20000 || cents > 1000000) return null;
      try {
        const r = await fetch(EC_API, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ articles: [{ identifier: 'cart', price: cents / 100 }] }),
        });
        const plan = (await r.json()).installmentPlans?.[0];
        if (!plan || plan.errors || !plan.plans?.length) return null;
        const example = new DOMParser().parseFromString(plan.example || '', 'text/html').body.textContent.trim();
        return { plans: plan.plans, example };
      } catch (e) {
        return null;
      }
    })();
    plansCache.set(cents, p);
    return p;
  }

  const offered = (plans) => {
    const pick = plans.filter((p) => TERMS.includes(p.numberOfInstallments));
    return pick.length ? pick : plans.slice(-5);
  };
  const planFor = (plans, n) =>
    plans.find((p) => p.numberOfInstallments === n) || offered(plans)[offered(plans).length - 1];

  async function renderCalc(box) {
    const cents = Number(box.dataset.ecAmount);
    const data = await getPlans(cents);
    const ok = box.querySelector('[data-ec-ok]');
    const range = box.querySelector('[data-ec-range]');
    box.hidden = false;
    if (!data) {
      ok.hidden = true;
      range.hidden = false;
      return null;
    }
    const list = offered(data.plans);
    if (!list.some((p) => p.numberOfInstallments === term)) term = list[list.length - 1].numberOfInstallments;
    const plan = planFor(data.plans, term);
    box.querySelector('[data-ec-rate]').textContent = eur(plan.installment);
    box.querySelector('[data-ec-term]').textContent = plan.numberOfInstallments;
    const terms = box.querySelector('[data-ec-terms]');
    terms.replaceChildren(
      ...list.map((p) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'a51c-ec__term';
        b.textContent = p.numberOfInstallments;
        b.setAttribute('aria-pressed', String(p.numberOfInstallments === term));
        b.setAttribute('aria-label', p.numberOfInstallments + ' Monate');
        b.addEventListener('click', () => {
          term = p.numberOfInstallments;
          initRates(document);
        });
        return b;
      })
    );
    box.querySelector('[data-ec-legal]').textContent =
      `${plan.numberOfInstallments} Monatsraten à ${eur(plan.installment)}, letzte Rate ${eur(plan.lastInstallment)}, ` +
      `Sollzinssatz ${plan.nominalInterestRate.replace('.', ',')} % p.a. (gebunden), ` +
      `effektiver Jahreszins ${plan.effectiveInterestRate.replace('.', ',')} %, ` +
      `Gesamtbetrag ${eur(plan.totalValue)}. ${data.example}`;
    return true;
  }

  async function renderLineRate(el) {
    const data = await getPlans(Number(el.dataset.ecAmount));
    if (!data) return (el.hidden = true);
    const plan = planFor(data.plans, term);
    el.querySelector('[data-ec-rate]').textContent = eur(plan.installment);
    el.title = `${plan.numberOfInstallments} Monate, eff. Jahreszins ${plan.effectiveInterestRate.replace('.', ',')} %`;
    el.hidden = false;
  }

  async function initRates(root) {
    const box = root.querySelector('[data-ec-calc]');
    if (box) await renderCalc(box);
    root.querySelectorAll('.a51c-rate[data-ec-amount]').forEach(renderLineRate);
  }

  /* --- Start + nach jedem Neu-Rendern durch cart.js ------------------------ */
  function init() {
    const root = document.getElementById('main-cart-items');
    if (!root) return;
    initImages(root);
    initRates(root);
  }

  function start() {
    init();
    const target = document.getElementById('main-cart-items');
    if (target) new MutationObserver(() => init()).observe(target, { childList: true, subtree: false });
    const inner = target && target.querySelector('.js-contents');
    if (inner) new MutationObserver(() => init()).observe(inner, { childList: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
